import { PageTemplate } from "@/shared/ui/templates"
import { CrossmixingHeader } from "../../components/cross-mixing-header"
import { CrossMixingContent } from "../../components/cross-mixing-content"

export const CrossMixingPage = () => {
    return(
    <PageTemplate header="наилучшие миксы между всеми складами" customBack="/mixing">
        <CrossmixingHeader/>
        <CrossMixingContent/>
    </PageTemplate>)
}